import React from "react";
import "../styles/Header.css";
import Status from "./Status";
import { useNavigate } from "react-router-dom";

function Header() {
  const navigate = useNavigate();

  return (
    <header className="header">
      <div className="header-inner">
        <div className="header-content pointer" onClick={() => navigate("/")}>
          <div className="brand-logos" aria-label="PGMBM">
            <img
              src="/images/pgmbm-logo-white.png"
              srcSet="/images/pgmbm-logo-white.png 1x, /images/pgmbm-logo-white@2x.png 2x"
              width="103"
              height="120"
              alt="PGMBM"
              className="partner-logo-img"
            />
          </div>
        </div>

        <div className="header-info">
          <Status />
        </div>
      </div>
    </header>
  );
}

export default Header;
